export const GET_MATCHES = 'GET_MATCHES'
export const GET_LAST_MATCH = 'GET_LAST_MATCH'
export const REMOVE_MATCH_BY_ID = 'REMOVE_MATCH_BY_ID'
export const PUSH_MATCHES = 'PUSH_MATCHES'
export const SET_PERSON_FOR_MATCH = 'SET_PERSON_FOR_MATCH'
